import { createApp } from 'vue';
import GetReportForm from './components/general/GetReportForm.vue'

const appElements = document.querySelectorAll('.vue-get-form-view')
Array.from(appElements).forEach(element => {
    createApp(GetReportForm).mount(element);
});